import {
  endOfMonth,
  endOfWeek,
  endOfYear,
  format,
  isToday,
  isSameDay as sameDay,
  startOfMonth,
  startOfWeek,
  startOfYear,
} from 'date-fns'
import { ru } from 'date-fns/locale'
import { DateRange } from 'react-day-picker'

export function getLabel(date: DateRange | undefined, isMobile: boolean = false): string {
  if (!date?.from) return 'Выберите дату'

  const { from, to } = date

  if (!to) {
    if (isToday(from)) return 'Сегодня'
    return format(from, isMobile ? 'dd.MM.yy' : 'LLL dd, y', { locale: ru })
  }

  // Ровно один день
  if (sameDay(from, to)) {
    return isToday(from)
      ? 'Сегодня'
      : format(from, isMobile ? 'dd.MM.yy' : 'LLL dd, y', { locale: ru })
  }

  // Ровно неделя
  if (
    sameDay(from, startOfWeek(from, { locale: ru })) &&
    sameDay(to, endOfWeek(from, { locale: ru }))
  ) {
    return 'Неделя'
  }

  // Ровно месяц
  if (sameDay(from, startOfMonth(from)) && sameDay(to, endOfMonth(from))) {
    return 'Месяц'
  }

  // Ровно год
  if (sameDay(from, startOfYear(from)) && sameDay(to, endOfYear(from))) {
    return 'Год'
  }

  // Разные случаи — форматирование зависит от размера экрана
  if (isMobile) {
    return `${format(from, 'dd.MM.yy', { locale: ru })} - ${format(to, 'dd.MM.yy', { locale: ru })}`
  }

  return `${format(from, 'LLL dd, y', { locale: ru })} - ${format(to, 'LLL dd, y', { locale: ru })}`
}
